import { useApiService } from '../services/apiServices';

const useAffidavitService = () => {
    const handleApiRequest = useApiService();

   
    const fetchAllAffidavitData = async () => {
        try {
            let affidavitResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/affidavit/all`,
                "GET"
            );
            return affidavitResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    const fetchMyAffidavitData = async () => {
        try {
            let affidavitResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/affidavit/myrequests`,
                "GET"
            );
            return affidavitResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    const fetchAllCourts = async () => {
        try {
            const courtResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/court/all`,
                "GET"
            );
            return courtResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };
    const fetchAllCourtDivisions = async () => {
        try {
            const courtDivisionResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/court/divisions/all`,
                "GET"
            );
            return courtDivisionResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    const fetchAllAdmin = async () => {
        try {
            let adminResponse = await handleApiRequest(
                `${process.env.REACT_APP_API_BASE_URL}/admin/all`,
                "GET"
            );
            console.log("Admin response:", adminResponse);
            return adminResponse;
        } catch (error) {
            console.error("Failed to fetch data:", error);
            throw error;
        }
    };

    return { fetchAllAffidavitData, fetchMyAffidavitData, fetchAllCourts,fetchAllCourtDivisions,fetchAllAdmin};
};

export default useAffidavitService;